import { gql } from "@apollo/client";

export const EXPORT_CONSOLIDATION_TASKS = gql`
  mutation ExportConsolidationTasks($taskIds: [String!]!) {
    exportConsolidationTasks(taskIds: $taskIds)
  }
`;

export interface ExportConsolidationTasksVariables {
  taskIds: string[];
}

export interface ExportConsolidationTasksResponse {
  exportConsolidationTasks: string;
}
